import React from "react";
import { NavDropdown } from "react-bootstrap";

// This component is a menu collection of actions related to grouping/ungrouping
// columns in the Ag-Grid
function GroupingSelector(props) {
  const { columnDefs, gridApi, gridColumnApi } = props;

  const expandAll = (expand) => {
    const groupNames = [];

    gridColumnApi.getAllDisplayedColumnGroups().forEach((columnGroup) => {
      const { groupId } = columnGroup;
      if (groupId) {
        groupNames.push(groupId);
      }
    });

    groupNames.forEach((groupId) => {
      gridColumnApi.setColumnGroupOpened(groupId, expand);
    });
  };

  const getFlatColumns = () => {
    const flatColumnDefs = [];

    // Don't make this an arrow function; it will not work with recursion!
    function addColumn(columnDef) {
      if (columnDef.children) {
        for (const col of columnDef.children) {
          addColumn(col); // recursive call!
        }
      } else {
        flatColumnDefs.push(columnDef);
      }
    }

    for (const col of columnDefs) {
      addColumn(col);
    }

    return flatColumnDefs;
  };

  const hideGroups = (event) => {
    event.preventDefault();
    const flatColumnDefs = getFlatColumns(columnDefs).map((col) => {
      if (col.field === "jhed" || col.field === "email") {
        col.pinned = null;
      }
      return col;
    });
    gridApi.setColumnDefs(flatColumnDefs);
  };

  const showGroups = (event) => {
    event.preventDefault();
    const originalColDefs = columnDefs.map((col) => {
      if (col.groupId === "PersonalGroup") {
        col.children = col.children.map((c) => {
          if (c.field === "jhed" || c.field === "email") {
            c.pinned = "left";
          }
          return c;
        });
      }
      return col;
    });
    gridApi.setColumnDefs(originalColDefs);
  };

  return (
    <NavDropdown title="Group" id={"nav-bar-group"}>
      <NavDropdown.Item onClick={showGroups}>
        Group related columns
      </NavDropdown.Item>
      <NavDropdown.Item onClick={() => expandAll(true)}>
        Expand all groups
      </NavDropdown.Item>
      <NavDropdown.Item onClick={() => expandAll(false)}>
        Contract all groups
      </NavDropdown.Item>
      <NavDropdown.Item onClick={hideGroups}>
        Ungroup all columns
      </NavDropdown.Item>
    </NavDropdown>
  );
}

export default GroupingSelector;
